@if (componentData.data$ | async; as data) {
  <div [class.background--dark]="getBackgroundColor(data.backgroundColor)">
    <div
      class="image-text image-right container"
      [ngClass]="{
        'image-right': getAlignment(data.imageAlignment),
        'pb-0': data.removeBottomSpacing | safeCheck,
      }"
    >
      <div class="image-text__image">
        <boels-media
          [container]="data.image"
          [alt]="data.imageAltText ? data.imageAltText : data.image?.altText"
        ></boels-media>
      </div>
      <div class="image-text__content">
        <h2>{{ data.title }}</h2>
        <div
          boelsDynamicContentLinkHandler
          [innerHTML]="data.bodyText | prepareHtml"
        ></div>
        @if (data.link) {
          <a
            boelsAnchorButton
            boelsGenericLink
            tabindex="0"
            [attr.target]="data.link.target | urlTarget"
            [url]="data.link.url"
            [variant]="'primary-brand'"
          >
            {{ data.link.linkName ?? data.title }}
          </a>
        }
      </div>
    </div>
  </div>
}
